import { Link } from "react-router-dom";
import type { AnimeItem } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: AnimeItem }) {
  return (
    <Link
      to={`/detail/${anime.id}`}
      className="group block overflow-hidden rounded-xl bg-background-100 border border-background-200/60 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[2/3] overflow-hidden">
        <img
          src={anime.poster}
          alt={`${anime.title} 海报`}
          title={`${anime.title} 在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/80 via-transparent to-transparent" />
        <span className="absolute left-2 top-2 rounded-md bg-background-950/70 px-2 py-0.5 text-xs text-foreground-300 backdrop-blur-sm">
          {anime.category}
        </span>
        <span className="absolute right-2 top-2 inline-flex items-center gap-1 rounded-md bg-accent-500/90 px-1.5 py-0.5 text-xs font-medium text-background-950">
          <i className="ri-star-fill text-[10px]" />
          {anime.rating}
        </span>
        {/* play on hover */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
          <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-background-950 shadow-lg">
            <i className="ri-play-fill text-xl pl-0.5" />
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-300">
          {anime.title}
        </h3>
        <div className="mt-1.5 flex items-center justify-between text-xs text-foreground-600">
          <span>{anime.episodes}</span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line" />
            {anime.views}
          </span>
        </div>
      </div>
    </Link>
  );
}